import { Content, Header, Body } from 'launch/components/AppContent';
import { Switch } from 'react-router-dom';
import BriefHeader from 'launch/components/BriefHeader';
import BriefStatus from 'launch/components/BriefStatus';
import Portal from 'common/components/Portal';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Title from 'launch/components/Title';
import Viewport from 'common/utils/Viewport';
import routes from 'launch/routes';
import { getExperimentsSet } from 'launch/stores/DraftStore';

export class App extends Component {
    static childContextTypes = {
        viewport: PropTypes.instanceOf(Viewport),
    };

    getChildContext() {
        return {
            viewport: this.viewport,
        };
    }

    UNSAFE_componentWillMount() {
        this.viewport = new Viewport();
    }

    componentDidMount() {
        const experiments = getExperimentsSet(global.draft.body.experiments);

        if (
            experiments.has('dynamicInspirationInBrief:enabled') &&
            window.location.pathname.includes('/logo-design/')
        ) {
            return;
        }

        this.viewport.on('change', this.forceUpdate.bind(this));
    }

    componentWillUnmount() {
        this.viewport.removeAllListeners('change');
    }

    render() {
        return (
            <Content>
                <Title />

                <Portal portal="[data-status-container]">
                    <BriefStatus />
                </Portal>
                <Header>
                    <BriefHeader />
                </Header>
                <Body>
                    <Switch>{routes}</Switch>
                </Body>
            </Content>
        );
    }
}

export default App;
